import React from 'react';
import { Line as LineChart } from 'react-chartjs-2';
var Api = require('./Config');

export const getAstControlLabels = (value, concatenate) => {
  const labelMap = {
    1: ['Controlled/ ', 'Intermittent'],
    2: ['Partly Controlled/ ', 'Mild Persistent'],
    3: ['Uncontrolled/ ', 'Moderate Persistent'],
    4: ['Poorly Controlled/', 'Severe Persistent'],
  };

  let textValue = labelMap[value] || '';

  if (concatenate && textValue !== '') {
    textValue = textValue.join('');
  }

  return textValue;
};

const AsthmaControlChart = ({ data, width, height, title, leftPadding, displayTime = false }) => {
  const plugins = [
    {
      beforeDraw: (chart) => {
        if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
          var ctx = chart.chart.ctx;
          var chartArea = chart.chartArea;
          var rowCount = 5;
          var width = chartArea.right - chartArea.left;
          var height = chartArea.bottom - chartArea.top;
          var rowHeight = height / rowCount;
          ctx.save();

          // area for Poorly Controlled/Severe Persistent
          // starts 35px from the top
          var startPoint = chartArea.top + 35;

          var count = 0;

          // add color on the chart area from the top
          while (startPoint < chartArea.bottom) {
            ctx.fillStyle = chart.config.options.chartArea.backgroundColor[count];
            if (count < 4) {
              ctx.fillRect(chartArea.left, startPoint, width, rowHeight);
            }
            startPoint += rowHeight;
            count++;
          }

          ctx.restore();
        }
      },
    },
  ];

  let responsive = width || height ? false : true;

  return (
    <LineChart
      data={data}
      options={{
        legend: {
          display: false,
        },
        title: {
          display: true,
          fontSize: 25,
          text: title || '',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 5,
                stepSize: 1,
                callback: function (value) {
                  return getAstControlLabels(value, false);
                },
              },
              gridLines: {
                drawOnChartArea: true,
                offsetGridLines: true,
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
        },
        responsive: responsive,
        chartArea: {
          backgroundColor: ['#FF9C9D', '#F8D3BA', '#FFEAAC', '#CEE5C0'],
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              return getAstControlLabels(tooltipItem.yLabel, true);
            },
            beforeTitle: function (tooltipItems, data) {
              if (displayTime) {
                return Api.getDateFormat(data.labelTime[tooltipItems[0].index], false, 'h:MM tt');
              }
              return '';
            },
          },
        },
        layout: {
          padding: {
            left: leftPadding,
          },
        },
      }}
      width={width}
      height={height}
      plugins={plugins}
    />
  );
};

export default AsthmaControlChart;
